module.exports = __webpack_public_path__ + "static/media/verificaçãoDocOk.ebe199dc.jpg";